import { render, staticRenderFns } from "./LastNewsSideComponent.vue?vue&type=template&id=8ef4adb8&"
import script from "./LastNewsSideComponent.vue?vue&type=script&lang=js&"
export * from "./LastNewsSideComponent.vue?vue&type=script&lang=js&"
import style0 from "./LastNewsSideComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports